const uiKitRoutes = []
const hostname = window?.location?.hostname ?? ''
const isSandboxHost = hostname.includes('sandbox')
const isStagingHost = hostname.includes('staging')
const isUiKitEnabled = !import.meta.env.PROD || isSandboxHost || isStagingHost

if (isUiKitEnabled) {
  uiKitRoutes.push({
    path: 'ui-kit',
    name: 'UiKitGallery',
    component: () => import('@/pages/ui-kit/UiKitGallery.vue'),
    meta: {
      layout: 'empty',
      requiresAuth: false
    }
  })
}

export default uiKitRoutes
